import React, { useRef } from "react";
import "./ScrollCasino.css";
import Helper from "../../helper";
import axios from 'axios';
import Appconfig from '../../config/config'
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";


const ScrollCasino = () => {
  const userInfo = Helper(); // get login user details
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: 'https://daddyexch.live/',
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error('Game Not Found.', { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function OpenEzugiLobby(casinoType) {
    navigate('/all-games-lobby', { state: { activeCasino: casinoType } });
  }

  // Scroll handler for nav buttons
  const scrollByAmount = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  // Touch drag support (optional, for better mobile UX)
  let isDown = false, startX, scrollLeft;
  const handleTouchStart = (e) => {
    isDown = true;
    startX = e.touches[0].pageX - scrollRef.current.offsetLeft;
    scrollLeft = scrollRef.current.scrollLeft;
  };
  const handleTouchMove = (e) => {
    if (!isDown) return;
    const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
    const walk = (startX - x);
    scrollRef.current.scrollLeft = scrollLeft + walk;
  };
  const handleTouchEnd = () => { isDown = false; };

  // All your game buttons as an array for easier mapping
  const games = [
    { provider: 'DC', code: '901034', img: 'Super_Over.webp', alt: 'Super Over' },
    { provider: 'DC', code: '900008', img: '3_Cards_Judgement.webp', alt: '3 Cards Judgement' },
    { provider: 'DC', code: '900088', img: 'Live_Teenpatti.webp', alt: 'Live Teenpatti' },
    { provider: 'AC', code: '567681', type: 'EV', img: 'Teenpatti_T20.webp', alt: 'Teenpatti T20' },
    { provider: 'AC', code: '676302', type: 'EV', img: 'Teenpatti_Test.webp', alt: 'Teenpatti Test' },
    { provider: 'DC', code: '151015', img: '2_Cards_Teenpatti.webp', alt: '2 Cards Teenpatti' },
    { provider: 'DC', code: '150049', img: 'Teenpatti_Open.webp', alt: 'Teenpatti Open' },
    { provider: 'DC', code: '150030', img: 'Muflis_Teenpatti.webp', alt: 'Muflis Teenpatti' },
    { provider: 'DC', code: '151009', img: 'dragon_tiger.webp', alt: 'Dragon Tiger' },
    { provider: 'DC', code: '151012', img: '32_cards_casino.webp', alt: '32 Cards Casino' },
    { provider: 'DC', code: '151007', img: 'Bollywood_Casino.webp', alt: 'Bollywood Casino' },
    { provider: 'DC', code: '151008', img: 'Amar_Akbar_Anthony.webp', alt: 'Amar Akbar Anthony' },
    { provider: 'DC', code: '151016', img: 'queen.webp', alt: 'Queen' },
    { provider: 'DC', code: '150052', img: 'Baccarat.webp', alt: 'Baccarat' },
    { provider: 'DC', code: '151022', img: '29_Card_Baccarat.webp', alt: '29 Card Baccarat' },
    { provider: 'DC', code: '150018', img: 'Casino_War.webp', alt: 'Casino War' },
    { provider: 'DC', code: '151010', img: 'Casino_Meter.webp', alt: 'Casino Meter' },
    { provider: 'DC', code: '151004', img: 'Trio.webp', alt: 'Trio' },
    { provider: 'DC', code: '150051', img: 'Hi_Low.webp', alt: 'Hi Low' },
    { provider: 'DC', code: '150017', img: 'Race_20_20.webp', alt: 'Race 20 20' },
    { provider: 'DC', code: '150043', img: 'Race_to_17.webp', alt: 'Race to 17' },
    { provider: 'DC', code: '900001', img: '7_up_Down.webp', alt: '7 Up Down' },
    { provider: 'DC', code: '150007', img: 'Andar_Bahar.webp', alt: 'Andar Bahar' },
    { provider: 'DC', code: '151017', img: 'Poker.webp', alt: 'Poker' },
    { provider: 'DC', code: '150005', img: 'Poker_20_20.webp', alt: 'Poker 20 20' },
    { provider: 'Ac', code: '675652', type: 'EV', img: 'Six_player_poker.webp', alt: 'Six Player Poker' },
    { provider: 'DC', code: '901037', img: 'The_Trap.webp', alt: 'The Trap' },
    { provider: 'DC', code: '150019', img: 'Worli_Matka.webp', alt: 'Worli Matka' },
    { provider: 'DC', code: '151019', img: 'Roulette.webp', alt: 'Roulette' },
    { provider: 'AC', code: '985661', type: 'EV', img: 'Sicbo.webp', alt: 'Sicbo' },
    { provider: 'AC', code: '985672', type: 'EV', img: 'dream_catcher.webp', alt: 'Dream Catcher' },
  ];

  // Split games into columns of 3 (for 3 rows)
  const columns = [];
  for (let i = 0; i < games.length; i += 3) {
    columns.push(games.slice(i, i + 3));
  }

  return (
    <>
    {/* Popular Games Start */}
      <div className="live-casino" style={{ background: '#ffffff'}}>
        {/* <div className="live-casino-heading">
          <p>Popular Games</p>
        </div> */}
        {/* <div className="scrollable-box">
          <div className="inner-box scroll-casino" style={{ marginBottom: '4px' }}>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `901034`)} className="image-setting">
              <img src="../Images/Popular_games/Super_Over.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `900008`)} className="image-setting">
              <img src="../Images/Popular_games/3_Cards_Judgement.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `900088`)} className="image-setting">
              <img src="../Images/Popular_games/Live_Teenpatti.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('AC', '567681', 'EV')} className="image-setting">
              <img src="../Images/Popular_games/Teenpatti_T20.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`AC`, `676302`, `EV`)} className="image-setting">
              <img src="../Images/Popular_games/Teenpatti_Test.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151015`)} className="image-setting">
              <img src="../Images/Popular_games/2_Cards_Teenpatti.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150049`)} className="image-setting">
              <img src="../Images/Popular_games/Teenpatti_Open.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150030`)} className="image-setting">
              <img src="../Images/Popular_games/Muflis_Teenpatti.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151009`)} className="image-setting">
              <img src="../Images/Popular_games/dragon_tiger.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151012`)} className="image-setting">
              <img src="../Images/Popular_games/32_cards_casino.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151007`)} className="image-setting">
              <img src="../Images/Popular_games/Bollywood_Casino.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151008`)} className="image-setting">
              <img src="../Images/Popular_games/Amar_Akbar_Anthony.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151016')} className="image-setting">
              <img src="../Images/Popular_games/queen.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150052`)} className="image-setting">
              <img src="../Images/Popular_games/Baccarat.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151022`)} className="image-setting">
              <img src="../Images/Popular_games/29_Card_Baccarat.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150018`)} className="image-setting">
              <img src="../Images/Popular_games/Casino_War.webp" alt="" />
            </button>
          </div>
          <div className="inner-box scroll-casino" style={{ marginBottom: '7px' }}>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151010`)} className="image-setting">
              <img src="../Images/Popular_games/Casino_Meter.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151004`)} className="image-setting">
              <img src="../Images/Popular_games/Trio.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150051`)} className="image-setting">
              <img src="../Images/Popular_games/Hi_Low.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150017`)} className="image-setting">
              <img src="../Images/Popular_games/Race_20_20.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150043`)} className="image-setting">
              <img src="../Images/Popular_games/Race_to_17.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `900001`)} className="image-setting">
              <img src="../Images/Popular_games/7_up_Down.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150007`)} className="image-setting">
              <img src="../Images/Popular_games/Andar_Bahar.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151017')} className="image-setting">
              <img src="../Images/Popular_games/Poker.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150005`)} className="image-setting">
              <img src="../Images/Popular_games/Poker_20_20.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`Ac`, `675652`, `EV`)} className="image-setting">
              <img src="../Images/Popular_games/Six_player_poker.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `901037`)} className="image-setting">
              <img src="../Images/Popular_games/The_Trap.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `150019`)} className="image-setting">
              <img src="../Images/Popular_games/Worli_Matka.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`DC`, `151019`)} className="image-setting">
              <img src="../Images/Popular_games/Roulette.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`AC`, `985661`, `EV`)} className="image-setting">
              <img src="../Images/Popular_games/Sicbo.webp" alt="" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino(`AC`, `985672`, `EV`)} className="image-setting">
              <img src="../Images/Popular_games/dream_catcher.webp" alt="" />
            </button>
          </div>
        </div> */}
        <div className="header-container">
          <div className="title" style={{ color: "#000" }}>Popular Games</div>
          <div className="nav-buttons">
            <div className="nav-button" onClick={() => scrollByAmount(-220)}>
              {/* Left Arrow */}
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" height="auto" width="10" xmlns="http://www.w3.org/2000/svg">
                <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
              </svg>
            </div>
            <div className="nav-button" onClick={() => scrollByAmount(220)}>
              {/* Right Arrow */}
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" height="auto" width="10" xmlns="http://www.w3.org/2000/svg">
                <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path>
              </svg>
            </div>
          </div>
        </div>

        <div
            className="scrollable-box three-row-scroll"
            ref={scrollRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
          {/* <div className="inner-box scroll-casino" style={{ marginBottom: '4px' }}>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '901034')} className="image-setting">
              <img src="../Images/Popular_games/Super_Over.webp" alt="Super Over" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '900008')} className="image-setting">
              <img src="../Images/Popular_games/3_Cards_Judgement.webp" alt="3 Cards Judgement" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '900088')} className="image-setting">
              <img src="../Images/Popular_games/Live_Teenpatti.webp" alt="Live Teenpatti" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('AC', '567681', 'EV')} className="image-setting">
              <img src="../Images/Popular_games/Teenpatti_T20.webp" alt="Teenpatti T20" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('AC', '676302', 'EV')} className="image-setting">
              <img src="../Images/Popular_games/Teenpatti_Test.webp" alt="Teenpatti Test" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151015')} className="image-setting">
              <img src="../Images/Popular_games/2_Cards_Teenpatti.webp" alt="2 Cards Teenpatti" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150049')} className="image-setting">
              <img src="../Images/Popular_games/Teenpatti_Open.webp" alt="Teenpatti Open" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150030')} className="image-setting">
              <img src="../Images/Popular_games/Muflis_Teenpatti.webp" alt="Muflis Teenpatti" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151009')} className="image-setting">
              <img src="../Images/Popular_games/dragon_tiger.webp" alt="Dragon Tiger" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151012')} className="image-setting">
              <img src="../Images/Popular_games/32_cards_casino.webp" alt="32 Cards Casino" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151007')} className="image-setting">
              <img src="../Images/Popular_games/Bollywood_Casino.webp" alt="Bollywood Casino" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151008')} className="image-setting">
              <img src="../Images/Popular_games/Amar_Akbar_Anthony.webp" alt="Amar Akbar Anthony" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151016')} className="image-setting">
              <img src="../Images/Popular_games/queen.webp" alt="Queen" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150052')} className="image-setting">
              <img src="../Images/Popular_games/Baccarat.webp" alt="Baccarat" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151022')} className="image-setting">
              <img src="../Images/Popular_games/29_Card_Baccarat.webp" alt="29 Card Baccarat" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150018')} className="image-setting">
              <img src="../Images/Popular_games/Casino_War.webp" alt="Casino War" />
            </button>
          </div>

          <div className="inner-box scroll-casino" style={{ marginBottom: '7px' }}>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151010')} className="image-setting">
              <img src="../Images/Popular_games/Casino_Meter.webp" alt="Casino Meter" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151004')} className="image-setting">
              <img src="../Images/Popular_games/Trio.webp" alt="Trio" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150051')} className="image-setting">
              <img src="../Images/Popular_games/Hi_Low.webp" alt="Hi Low" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150017')} className="image-setting">
              <img src="../Images/Popular_games/Race_20_20.webp" alt="Race 20 20" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150043')} className="image-setting">
              <img src="../Images/Popular_games/Race_to_17.webp" alt="Race to 17" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '900001')} className="image-setting">
              <img src="../Images/Popular_games/7_up_Down.webp" alt="7 Up Down" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150007')} className="image-setting">
              <img src="../Images/Popular_games/Andar_Bahar.webp" alt="Andar Bahar" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151017')} className="image-setting">
              <img src="../Images/Popular_games/Poker.webp" alt="Poker" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150005')} className="image-setting">
              <img src="../Images/Popular_games/Poker_20_20.webp" alt="Poker 20 20" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('Ac', '675652', 'EV')} className="image-setting">
              <img src="../Images/Popular_games/Six_player_poker.webp" alt="Six Player Poker" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '901037')} className="image-setting">
              <img src="../Images/Popular_games/The_Trap.webp" alt="The Trap" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '150019')} className="image-setting">
              <img src="../Images/Popular_games/Worli_Matka.webp" alt="Worli Matka" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('DC', '151019')} className="image-setting">
              <img src="../Images/Popular_games/Roulette.webp" alt="Roulette" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('AC', '985661', 'EV')} className="image-setting">
              <img src="../Images/Popular_games/Sicbo.webp" alt="Sicbo" />
            </button>
            <button onClick={() => CreateAndLaunchWCOCasino('AC', '985672', 'EV')} className="image-setting">
              <img src="../Images/Popular_games/dream_catcher.webp" alt="Dream Catcher" />
            </button>
          </div> */}

          <div className="scroll-casino-grid">
            {columns.map((col, colIdx) => (
              <div className="scroll-casino-col" key={colIdx}>
                {col.map((game, rowIdx) => (
                  <button
                    key={game.code + rowIdx}
                    onClick={() => CreateAndLaunchWCOCasino(game.provider, game.code, game.type)}
                    className="image-setting"
                  >
                    <img src={`../Images/Popular_games/${game.img}`} alt={game.alt} />
                  </button>
                ))}
              </div>
            ))}
          </div>


        </div>

      </div>
    {/* Popular Games End */}

    {/* Casino Provider Start */}
      <div className="casino-background">
        <div className="live-casino" style={{ background: '#ffffff'}}>
          <div className="header-container" style={{ padding: '10px 0' }}>
            <div className="title" style={{ color: "#000" }}>Casino Provider</div>
          </div>
          <div className="scrollable-box">
            <div className="casino-provider-layout">
              <div className="grid-cols-div">
                <div
                  onClick={() => OpenEzugiLobby('evolution')}
                  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/evolution.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/ezugi.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('jilli-casino')}  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/jili.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div
                  onClick={() => OpenEzugiLobby('ezugi')} 
                  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/gamzix.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('kingmaker-casino')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/kingmaker.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('smartsoft-casino')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/smartsoft.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('mac888')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/mac88virtualgame.webp" alt="" style={{ width: '100%' }} />
                </div>
                {/* <div onClick={() => CreateAndLaunchWCOCasino(`BGS`, ``, '')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/playtech.webp" alt="" style={{ width: '100%' }} />
                </div> */}
                <div onClick={() => OpenEzugiLobby('mac888')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/mac88.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('mac888')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/vsport.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('evolution')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/evoplay.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')}  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/fungames_500-299.webp" alt="" style={{ width: '100%' }} />
                </div>
                {/* <div onClick={() => CreateAndLaunchWCOCasino()} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/bombaylive.webp" alt="" style={{ width: '100%' }} />
                </div> */}
                <div onClick={() => OpenEzugiLobby('bet-games')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/betgames.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')}  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/aesexy.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('spribe')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/spribe.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/turbogames.webp" alt="" style={{ width: '100%' }} />
                </div>
                {/* <div onClick={() => CreateAndLaunchWCOCasino()} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/vivogaming.webp" alt="" style={{ width: '100%' }} />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    {/* Casino Provider End */}
    </>
  );
};

export default ScrollCasino;
